module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/summary-remarks/summary-remarks.component.css
// module id = ./src/app/summary-remarks/summary-remarks.component.css
// module chunks = main